import { ChangeDetectionStrategy, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { MatSlideToggleChange } from '@angular/material/slide-toggle/slide-toggle';
import { ApiGridFilters } from '@app/infrastructure/data-list/grid/api-grid-filters/api-grid-filters';
import { FilterSelection } from '@app/infrastructure/filters/filter-selection';
import { GridFilterConfig } from '@app/infrastructure/filters/grid-filters/grid-filter.model';
import { UserService } from '@app/services/user/user.service';
import {
	COMMITMENT_FILTERS,
	CommitmentFilterNames,
	ICommitmentFilters,
} from '@modules/potential-save-modal/commitment-list/commitment.model';
import moment from 'moment/moment';

@Component({
	selector: 'app-commitment-filters',
	templateUrl: './commitment-filters.component.html',
	styleUrls: ['./commitment-filters.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CommitmentFiltersComponent implements OnInit, OnDestroy {
	@Input() public apiGridFilters?: ApiGridFilters<ICommitmentFilters>;

	public readonly isPurchaseWithin7DaysShown = this.userService.isZestyEmployee();
	public readonly commitmentFilters = CommitmentFilterNames;
	public readonly filterSelection: FilterSelection<ICommitmentFilters> = FilterSelection.create();
	private readonly filterConfig: GridFilterConfig<ICommitmentFilters>[] = COMMITMENT_FILTERS;
	private readonly dateFormat = 'YYYY-MM-DD';

	constructor(private userService: UserService) {}

	public ngOnInit(): void {
		if (!this.apiGridFilters) return;
		this.filterSelection.registerFiltersForm(this.filterConfig, this.apiGridFilters);
	}

	public ngOnDestroy(): void {
		this.filterSelection.dispose();
	}

	public applyFilter(): void {
		this.apiGridFilters.refresh();
	}

	public onSupportedChange({ checked }: MatSlideToggleChange): void {
		this.apiGridFilters.update({ is_supported: checked });
	}

	public onExpiredChange({ checked }: MatSlideToggleChange): void {
		this.apiGridFilters.update({ expired: checked });
	}

	public onStartChange({ checked }: MatSlideToggleChange): void {
		const start = checked ? moment().add(-7, 'day').format(this.dateFormat) : null;
		this.apiGridFilters.update({ start });
	}

	public onEndChange({ checked }: MatSlideToggleChange): void {
		const end = checked ? moment().add(12, 'month').format(this.dateFormat) : null;
		this.apiGridFilters.update({ end });
	}
}
